import icon from 'vue-svgicon';

icon.register({
    'light/gauge-dashboard': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<circle pid="0" cx="12" cy="14" r="1.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M13.06 12.939l4.951-4.949M2.5 14.5h2M21.5 14.5h-2M20.776 10.365l-1.847.765M15.635 5.223l-.765 1.848M12 4.5v2M8.365 5.223l.765 1.848M5.283 7.282l1.412 1.415M3.224 10.365l1.846.765M12 2.5A11.5 11.5 0 0 0 .5 14v3.5a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1V14A11.5 11.5 0 0 0 12 2.5z"/>`,
    },
});
